import backgroundImage from './assets/background.png';
import lionsImage from './assets/Logo-myn.png';
import { Button, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

export default function ResponsivePage() {
  const navigate = useNavigate();

  return (
    <div
      className="relative min-h-screen text-white font-sans overflow-hidden"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      {/* Overlay for readability */}
      <div className="absolute inset-0 bg-black/60"></div>

      {/* Header — fixed at the top */}
      <header className="fixed top-0 left-0 w-full py-6 px-6 md:px-12 text-center md:text-left backdrop-blur-sm bg-white/20 z-20">
        <h1
          className="text-3xl md:text-4xl font-bold"
          style={{ color: 'rgb(73, 16, 14)' }}
        >
          Mynämäen joulukonsertti
        </h1>
        <p className="text-gray-200 text-base md:text-lg">Anne Mattilan joulu</p>
      </header>

      {/* Scrollable Main Section */}
      <main className="absolute top-[120px] bottom-[120px] left-0 right-0 overflow-y-auto flex flex-col items-center px-6 md:px-12 text-center z-10">
        <div className="max-w-2xl mt-4 mb-10">
          <h2 className="text1st">Mynämäen Pyhän Laurin kirkko</h2>
          <h2 className="text1st">Kirkkokatu 3</h2>
          <h2 className="text1st">Tiistaina 1.12.2026</h2>
          <h2 className="text1st">Klo 18.00 - 19.00</h2>
          <h2 className="text1st">Liput 25 € / kpl</h2>

          <Container
            className="d-flex justify-content-center gap-3 mt-5"
            style={{ maxWidth: '300px' }}
          >
            <Button
              variant="outline-dark"
              className="flex-fill w-50 text-white"
              onClick={() => navigate('/varaa')}
            >
              Varaa
            </Button>
            <Button
              variant="outline-dark"
              className="w-50 flex-fill text-white"
              onClick={() => navigate('/peruutavaraus')}
            >
              Peruuta varaus
            </Button>
          </Container>
        </div>
      </main>

      {/* Footer — fixed at the bottom */}
      <footer className="fixed bottom-0 left-0 w-full py-6 text-center text-gray-400 text-sm border-t border-white/20 backdrop-blur-sm bg-white/20 z-20">
               <div className="logot-bck">
        
      </div>
      <img className="logot" src={lionsImage} alt="A picture of a lion"></img>
      </footer>
    </div>
  );
}



